import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';

const CopyrightBar = () => {
  const { t } = useLanguage();

  return (
    <div className="bg-gray-800 text-white w-full py-4">
      <div className="max-w-[1753px] mx-auto px-4 flex items-center justify-center">
        <p className="text-sm">
          {t('footer.copyright', { year: new Date().getFullYear() })}
        </p>
      </div>
    </div>
  );
};

export default CopyrightBar;